/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `a` - Categoria A
 * * `b` - Categoria B
 */
export enum MedicalCategory {
  A = 'a',
  B = 'b',
}
